module.exports = __webpack_public_path__ + "static/media/collections.884aa8c7.jpg";